import React from 'react';

export default () => (
  <header className="usage-page__no-spaces-placeholder">
    Usage will be available after you created your first space.
  </header>
);



// WEBPACK FOOTER //
// ./src/javascripts/account/usage/NoSpacesPlaceholder.es6.js